export default {
  productSection: {
    title: {
      fr: "Des produits visionnaires.",
      en: "",
    },
    items: {
      switches: {
        title: {
          fr: "Gardez le contrôle avec vos\n interrupteurs existants.",
          en: "",
        },
        description: {
          fr: "",
          en: "",
        },
        functions: {
          noWork: {
            title: {
              fr: "Sans travaux, sans compromis.",
              en: "No renovation, no compromise.",
            },
            subtitle: {
              fr: "Parce que la modernisation de votre espace de vie ou de travail ne devrait pas sacrifier son charme.",
              en: "Because upgrading your living or working space should never mean sacrificing its character.",
            },
            description: {
              fr: "Notre module de commande <strong>s’intègre discrètement derrière n’importe quel interrupteur</strong> et ne nécessite pas de fil.",
              en: "Our control module <strong>fits discreetly behind any switch</strong> and requires no additional wiring.",
            },
            conclusion: {
              fr: "Commandez vos équipements et déclenchez vos scènes favorites.",
              en: "Control your devices and trigger your favorite scenes instantly.",
            },
          },
          commandModule: {
            title: {
              fr: "Module de commande",
              en: "Command module",
            },
            description: {
              fr: "Invisible.",
              en: "Invisible.",
            },
            link: "https://www.polynhome.io/produit/nano-commande-sans-fil-2-voies",
          },
          noDemolition: {
            title: {
              fr: "Refaire sans défaire.",
              en: "Reinvent without rebuilding.",
            },
            description: {
              fr: "Sans intervention physique, reconfigurez vos interrupteurs depuis l’application au gré de vos agencements.",
              en: "Reconfigure your switches directly from the app, without any physical intervention, as your spaces evolve.",
            },
            conclusion: {
              fr: "Simple. Évolutif. Économique.",
              en: "Simple. Scalable. Cost-efficient.",
            },
          },
        },
      },
      products: {
        title: {
          fr: "Une gamme complète pour vos projets de rénovation et de construction.",
          en: "A complete range for both renovation and new construction projects.",
        },
        subtitle: {
          fr: "Conçu, fabriqué et assemblé en France.",
          en: "Designed, manufactured and assembled in France.",
        },
        description: {
          fr: "Des produits tout-terrain : format DIN et micromodules.",
          en: "Versatile products: DIN-rail modules and compact micromodules.",
        },
        productsList: {
          CONTROLLERDIN_1: {
            ref: "CONTROLLERDIN_1",
            link: "https://www.polynhome.io/produit/edge-computer-din",
            title: {
              fr: "Edge Computer",
              en: "",
            },
            subtitle: {
              fr: "Edge Computer",
              en: "Edge Computer",
            },
            description: {
              fr: "L'intelligence",
              en: "The brain",
            },
          },
          MULTISWITCHDIN_1: {
            ref: "MULTISWITCHDIN_1",
            link: "https://www.polynhome.io/produit/contacteur-din-2000w-4-voies",
            title: {
              fr: "Actionneur modulaire 4 sorties",
              en: "",
            },
            subtitle: {
              fr: "Volet - On/Off",
              en: "Roller shutter - On/Off",
            },
            description: {
              fr: "4 sorties - 2000w total",
              en: "4 channels - 2000w total",
            },
          },
          SWITCHDIN_1: {
            ref: "SWITCHDIN_1",
            link: "https://www.polynhome.io/produit/contacteur-din-16a",
            title: {
              fr: "Télérupteur",
              en: "",
            },
            subtitle: {
              fr: "On/Off",
              en: "On/Off",
            },
            description: {
              fr: "16A",
              en: "16A",
            },
          },
          MULTISWITCH_1: {
            ref: "MULTISWITCH_1",
            link: "https://www.polynhome.io/produit/micromodule-200w-2-voies",
            title: {
              fr: "Actionneur éclairage",
              en: "",
            },
            subtitle: {
              fr: "On/Off - Variateur",
              en: "On/Off - Dimmer",
            },
            description: {
              fr: "200w",
              en: "200w",
            },
          },
          MULTISWITCH_2: {
            ref: "MULTISWITCH_2",
            link: "https://www.polynhome.io/produit/micromodule-300w-volet",
            title: {
              fr: "Actionneur volet roulant",
              en: "",
            },
            subtitle: {
              fr: "Volet",
              en: "Roller shutter",
            },
            description: {
              fr: "300w",
              en: "300w",
            },
          },
          SWITCH_1: {
            ref: "SWITCH_1",
            link: "https://www.polynhome.io/produit/micromodule-contact-sec-10a",
            title: {
              fr: "Contacteur",
              en: "",
            },
            subtitle: {
              fr: "Contact sec - Fil pilote",
              en: "Dry contact - Pilote wire",
            },
            description: {
              fr: "2000w",
              en: "2000w",
            },
            features: {
              radiator: {
                fr: "Radiateur",
                en: "Radiator",
              },
              acccessControl: {
                fr: "Contrôle d'accès",
                en: "Access control",
              },
              shutters: {
                fr: "Contact sec",
                en: "Dry contact",
              },
            },
          },
          THERMOSTAT_1W: {
            ref: "THERMOSTAT_1W",
            link: "https://www.polynhome.io/produit/thermostat-dambiance-chauffage-climatisation",
            title: {
              fr: "Thermostat",
              en: "",
            },
            subtitle: {
              fr: "Thermostat",
              en: "Thermostat",
            },
            description: {
              fr: "Radiateurs - climatisation - plancher chauffant",
              en: "Radiators - AC - heated floors",
            },
          },
          COMMAND_1: {
            ref: "COMMAND_1",
            link: "https://www.polynhome.io/produit/nano-commande-sans-fil-2-voies",
            title: {
              fr: "Module de commande",
              en: "",
            },
            subtitle: {
              fr: "Commande sans fil",
              en: "Wireless switch",
            },
            description: {
              fr: "BP - inter - inter 3 positions",
              en: "Works with any wall switch",
            },
            features: {
              switch: {
                fr: "Interrupteur",
                en: "Switch",
              },
              bp: {
                fr: "Bouton poussoir",
                en: "Push button",
              },
              threePosition: {
                fr: "Interrupteur 3 positions",
                en: "Three position switch",
              },
            },
          },
          OPEN_1: {
            ref: "OPEN_1",
            link: "https://www.polynhome.io/produit/detecteur-douverture",
            title: {
              fr: "Détecteur d'ouverture",
              en: "",
            },
            subtitle: {
              fr: "Ouverture",
              en: "Open",
            },
            description: {
              fr: "Autonomie +15 ans",
              en: "Battery +15 years",
            },
          },
          MOTIONLIGHT_1: {
            ref: "MOTIONLIGHT_1",
            link: "https://www.polynhome.io/produit/capteur-de-mouvement-luminosite",
            title: {
              fr: "Capteur de mouvement & luminosité",
              en: "",
            },
            subtitle: {
              fr: "Mouvement & Luminosité",
              en: "Motion & Light",
            },
            description: {
              fr: "Autonomie +15 ans",
              en: "Battery +15 years",
            },
          },
          ENERGY1PN_1: {
            ref: "ENERGY1PN_1",
            link: "https://www.polynhome.io/produit/capteur-denergie-1pn",
            title: {
              fr: "Capteur d’énergie 1P+N",
              en: "",
            },
            subtitle: {
              fr: "Comptage énergie 1P",
              en: "Energy meter 1P",
            },
            description: {
              fr: "Jusqu'à 63A",
              en: "Up to 63A",
            },
          },
          REPEATER_1: {
            ref: "REPEATER_1",
            link: "https://www.polynhome.io/produit/nano-repeteur/",
            title: {
              fr: "Nano répéteur",
              en: "",
            },
            subtitle: {
              fr: "Nano répéteur",
              en: "Nano repeater",
            },
            description: {
              fr: "Compatible boite 40mm",
              en: "Fits 40 mm recess box",
            },
          },
        },
      },
    },
  },
};
